var VERSION = "MS4xNC4w";
var prefix = "-".concat(VERSION);
var lsgPre = "lsgs".concat(prefix, "--");
var lsgPreGlobal = "lsg".concat(prefix, "---");

export { lsgPre, lsgPreGlobal };
